export default __webpack_public_path__ + "static/media/team-header-logo-min.d3e6f46a.svg";